import { render, staticRenderFns } from "./PointSelections.vue?vue&type=template&id=3c8fec0d"
import script from "./PointSelections.vue?vue&type=script&lang=js"
export * from "./PointSelections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports